import Component from "../classes/Component";
import {$events} from "../helpers/events";
import {$dom} from "../helpers/dom";
import variables from "../variables";

const productGroupSelector = '.js-product-group';
const productDeleteSelector = '.js-product-delete'

const {get} = $dom

export default function () {
    const handleDelete = (e) => {
        get('svg', e.target).classList.add(variables.classNames.hidden)
        get('.spinner-border', e.target).classList.add(variables.classNames.visible)

        setTimeout(() => {
            get('svg', e.target).classList.remove(variables.classNames.hidden)
            get('.spinner-border', e.target).classList.remove(variables.classNames.visible)
        }, 1000)
    }

    return new Component({
        name: 'productDelete',
        requiredTargets: [productGroupSelector, productDeleteSelector],
        onInit() {
            $events.delegate
                .on('click', productDeleteSelector, handleDelete)
        },
        onDestroy() {
            console.log('productDelete')
        },
    })

}